// extracted by mini-css-extract-plugin
export default {"Label":"Label_Label__n+f0y","obligatory":"Label_obligatory__DZmXB"};